export default __webpack_public_path__ + "static/media/Mark-5-HUD-01.ea2a8942.jpg";